import { Link } from 'react-router-dom';
import { ApiUnavailablePanel } from '../../components/ui/ApiUnavailablePanel';
import { buttonBase, buttonVariants } from '../../components/ui/Button';

export function IntakeExplorerProgramsPage() {
  return (
    <div className="space-y-5">
      <ApiUnavailablePanel title="Program / submitter rollup">
        This rollup is not available yet. Use batch view for live intake data.
      </ApiUnavailablePanel>
      <Link to="/provider/intake" className={`${buttonBase} ${buttonVariants.ghost}`}>
        ← Back to batch view
      </Link>
    </div>
  );
}
